import React, { useContext } from 'react';
import styled from 'styled-components';
import { HexAlphaColorPicker } from 'react-colorful';
import rgbHex from 'rgb-hex';
import { faHashtag } from '@fortawesome/sharp-light-svg-icons';

import ThemeContext from '../../theme/ThemeContext';
import Icon from './Icon';
import Popover from './Popover';

import { isRgbaColor } from '../../lib/colors';

const StyledPopover = styled.div`
  padding: 0px 8px;
  .react-colorful {
    height: 120px !important;
    width: 140px !important;
  }

  .react-colorful__pointer {
    width: 20px !important;
    height: 20px !important;
  }

`;

const StyledColorInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;

  input {
    margin-left: 8px;
    padding: 6px;
    flex: 1;
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 6px;
    width: 100px;
    transition: all 0.15s ease-in-out;

    &:hover, &:focus {
      outline: unset; 
      border-style: solid;
      border-width: 1px !important;
      border-color: ${(props) => props.theme.primaryColor};
    }

  }

`;

const PopoverColorPicker = ({
  isOpen = false,
  positions = ['top', 'bottom', 'right', 'left'],
  value,
  onChange,
  children,
  onClickOutside
}) => {

  const theme = useContext(ThemeContext);

  let nextColor = value;

  /**
   * <----------------------NOTICE-------------------------->
   * value would be an empty string when user clears the picker using x mark
   * value would be transparent for backgroundColor.
   * In both these cases we should set the color to theme.secondaryColor.
   *
   * Border and bgcolor would be in rgba format for PDF Forms.
   * We are converting rgba to hex to prevent the color picker from giving NANAN values
   */

  if (!value || value === 'transparent') nextColor = theme.secondaryColor;

  if (nextColor && isRgbaColor(nextColor)) {

    nextColor = rgbHex(nextColor);

  }

  let timer = '';

  const handleChange = (val) => {

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      onChange(val);
    }, 200);

  };

  return (
    <Popover
      reposition={false}
      isOpen={isOpen}
      positions={positions} // preferred positions by priority
      onClickOutside={onClickOutside}
      content={(
        <StyledPopover theme={theme}>
          <HexAlphaColorPicker
            color={nextColor}
            onChange={handleChange}
          />
          <StyledColorInput theme={theme}>
            <Icon icon={faHashtag} color={theme.fontColorPrimary} />
            {' '}
            <input type="text" value={value === 'transparent' ? 'transparent' : value} onChange={(e) => handleChange(e.target.value)} />
          </StyledColorInput>
        </StyledPopover>
      )}
    >
      {children}
    </Popover>
  );

};

export default PopoverColorPicker;
